import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import DeletePaytoAccountAgreementPopup from './popup';

const DeletePaytoAccountAgreementModal = ({
  isShow,
  title,
  content,
  action,
  actionClose,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const handleOnClose = () => {
    closePortalModalName();
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
  };

  return (
    <DeletePaytoAccountAgreementPopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: isDesktop ? '124px' : '75px',
        height: isDesktop ? '100px' : '60px',
      }}
      text={title || t('form_delete_payto_account_title')}
      content={content || t('form_delete_payto_account_desc')}
      buttonLabel1={t('button_no')}
      onClose={handleOnClose}
      buttonLabel2={t('button_yes')}
      onClick={action}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      alignContent="center"
    />
  );
};

export default DeletePaytoAccountAgreementModal;
